import {lazy} from 'react'
import {Route, Routes} from 'react-router-dom'

export enum PrincipalRouterEnum {
    DatatableSchedule = '/principal/agenda',

    DatatableConsult = '/principal/consultas',
    ShowConsult = '/principal/consultas/:id',

    DatatableExam = '/principal/exames',
    ShowExam = '/principal/exames/:id',

    DatatableCoupon = '/principal/cupons',
    ShowCoupon = '/principal/cupons/:id',
    RegisterCoupon = '/principal/cupons/cadastro',
}

const DatatableSchedule = lazy(() => import('../../pages/schedule/SchedulePage'))

const DatatableConsult = lazy(() => import('../../pages/consults/DatatableConsult'))
const ShowConsult = lazy(() => import('../../pages/consults/ProfileConsult'))

const ShowSolicitationExam = lazy(
    () => import('../../pages/solicitations/exams/ShowSolicitation')
)
const ListSolicitationsExams = lazy(
    () => import('../../pages/solicitations/exams/ListSolicitations')
)

const DatatableCoupon = lazy(() => import('../../pages/consults/coupons/DatatableCoupons'))
const ShowCoupon = lazy(() => import('../../pages/consults/coupons/ShowCoupon'))
const RegisterCoupon = lazy(() => import('../../pages/consults/coupons/RegisterCoupon'))

export default function PrincipalRouter() {
    return (
        <Routes>
            {/* Paths relativos ao prefixo /principal consumido em PrivateRoutes */}
            {/*Rotas para Agenda*/}
            <Route path='agenda' element={<DatatableSchedule />} />

            {/*Rotas para Consultas*/}
            <Route path='consultas/:id' element={<ShowConsult />} />
            <Route path='consultas' element={<DatatableConsult />} />

            {/*Rotas para Exames*/}
            <Route path='exames/:id' element={<ShowSolicitationExam />} />
            <Route path='exames' element={<ListSolicitationsExams />} />

            {/*Rotas para Cupons*/}
            <Route path='cupons/cadastro' element={<RegisterCoupon />} />
            <Route path='cupons/:id' element={<ShowCoupon />} />
            <Route path='cupons' element={<DatatableCoupon />} />
        </Routes>
    )
}
